module.exports = __webpack_public_path__ + "img/mode2-1.9d7f79ca.png";